export const env = {
  // apiHost: "http://localhost:3033/",
  // frontUrl: "http://localhost:3000/",
  // apiHost: "https://voltrixcrypt.io:3033/",
  // frontUrl: "https://voltrixcrypt.io/",
  apiHost: "https://voltrixcrypt.online:3033/",
  frontUrl: "https://voltrixcrypt.online/",
  upload_preset: "sdfnunjedkaldkXVTLsdfojasdfsd",
  cloud_name: "daafoiwvn",

  // SITE_URL: "http://localhost:3000/",
  // SITE_URL: "https://voltrixcrypt.io/",
  SITE_URL: "https://voltrixcrypt.online/",
};
